import './index.scss'

import { Outlet } from 'react-router-dom'

import PageTabs from '@components/PageTabs'

export default function LaunchpadPage() {
  return (
    <div className='launchpad-page'>
      <PageTabs
        title='Launchpad'
        tabs={[
          // Hidden until we have the tags page built out.
          // { label: 'Views', path: '/launchpad' },
          // { label: 'Tags', path: '/launchpad/tags' }
        ]} />

      <Outlet />
    </div>
  )
}
